import { getItemsFromIdwellApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { getCategoriesNG } from '../Category.api'
import { toCategorySelectItems } from '../Category.utils'

import { CATEGORY_SELECT_DROPDOWN_FLOATING_CONFIG } from './CategorySelect.constants'

function CategorySelect({
  Control = InputSelectControl,
  dropdownFloatingConfig = CATEGORY_SELECT_DROPDOWN_FLOATING_CONFIG,
  getData = getCategoriesNG,
  getDataItems = getItemsFromIdwellApiResponse,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toCategorySelectItems}
    />
  )
}

export default CategorySelect
